import {} from "@econ-v1/domain";
import { isJsonValue } from "@econ-v1/rpc";
class AsyncStream {
    #domain;
    #onReturn;
    #pending = [];
    #waiters = [];
    #closed = false;
    constructor(domain, onReturn) {
        this.#domain = domain;
        this.#onReturn = onReturn;
    }
    [Symbol.asyncIterator]() {
        return this;
    }
    close() {
        if (this.#closed)
            return;
        this.#closed = true;
        for (const waiter of this.#waiters.splice(0))
            waiter.resolve({ done: true, value: undefined });
    }
    next() {
        const value = this.#pending.shift();
        if (value !== undefined)
            return Promise.resolve({ done: false, value });
        if (this.#closed)
            return Promise.resolve({ done: true, value: undefined });
        return new Promise((resolve, reject) => {
            this.#waiters.push({ reject, resolve });
        });
    }
    publish(value) {
        const waiter = this.#waiters.shift();
        if (waiter !== undefined) {
            waiter.resolve({ done: false, value });
            return;
        }
        this.#pending.push(value);
    }
    return() {
        this.close();
        this.#onReturn(this.#domain, this);
        return Promise.resolve({ done: true, value: undefined });
    }
}
export class WebSocketEventQueue {
    #streams = new Map();
    #closed = false;
    close() {
        if (this.#closed)
            return;
        this.#closed = true;
        for (const streams of this.#streams.values()) {
            for (const stream of streams)
                stream.close();
        }
        this.#streams.clear();
    }
    publish(event) {
        for (const stream of this.#streams.get(event.type) ?? [])
            stream.publish(event.data);
    }
    size(domain) {
        return Promise.resolve(this.#streams.get(domain)?.size ?? 0);
    }
    stream(options) {
        const stream = new AsyncStream(options.domain, (domain, current) => {
            const streams = this.#streams.get(domain);
            if (streams === undefined)
                return;
            streams.delete(current);
            if (streams.size === 0)
                this.#streams.delete(domain);
        });
        if (this.#closed) {
            stream.close();
            return stream;
        }
        const streams = this.#streams.get(options.domain) ?? new Set();
        streams.add(stream);
        this.#streams.set(options.domain, streams);
        return stream;
    }
}
export function createWebSocketEventQueue() {
    return new WebSocketEventQueue();
}
export function parseWebSocketEventMessage(serialized) {
    let value;
    try {
        value = JSON.parse(serialized);
    }
    catch {
        return undefined;
    }
    if (!isRecord(value) || typeof value.type !== "string" || !isJsonValue(value.data))
        return undefined;
    return { data: value.data, type: value.type };
}
function isRecord(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
//# sourceMappingURL=websocket-events.js.map